module.exports = __webpack_public_path__ + "img/jameson-1.623d2e2b.png";